import React, { ChangeEvent, FC, JSX, ReactElement } from 'react';
import { Input, InputProps } from 'reactstrap';
import classNames from 'classnames';
import { sanitize } from '@ibe/services';

export interface CustomInputProps extends InputProps {
  label?: string | ReactElement;
  className?: string;
  htmlFor?: string;
}

const CustomInput: FC<CustomInputProps> = (props: CustomInputProps): JSX.Element => {
  const { label, className, htmlFor, id, onChange, type, ...inputProps } = props;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!!onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className={classNames('custom-control', className || '', {
        'custom-checkbox': type === 'checkbox'
      })}
    >
      <Input
        className="custom-control-input"
        id={id}
        onChange={handleChange}
        type={type}
        {...inputProps}
      />
      {((!!label && typeof label !== 'string') || type === 'checkbox') && (
        <label className="custom-control-label" htmlFor={htmlFor || id}>
          {label || ''}
        </label>
      )}
      {!!label && typeof label === 'string' && type !== 'checkbox' && (
        <label
          className="custom-control-label"
          htmlFor={htmlFor || id}
          dangerouslySetInnerHTML={{ __html: sanitize(label) }}
        />
      )}
    </div>
  );
};

export default CustomInput;
